import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { breakpoint } from '@styles/breakpoints';
import { ActionButton } from '@styles/globalStyles';

export const Cover = styled.img`
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const Details = styled.div`
  flex: 1;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: ${({ view }) =>
    view === 'grid' ? 'flex-end' : 'space-between'};
`;

export const Title = styled.h2`
  font-weight: 500;
`;

export const Release = styled.h3`
  font-weight: 400;
  font-size: 12px;
  text-transform: uppercase;
  margin-top: 5px;
`;

export const Album = styled.div`
  color: #000;
  ${({ view }) => {
    if (view === 'grid') {
      return css`
        margin: 10px;
        padding: 5px;
        border: 1px rgba(0, 0, 0, 0.1) solid;
        width: calc(25% - 20px);
        display: flex;
        flex-direction: column;
        ${Cover} {
          object-fit: contain;
          height: auto;
          margin-bottom: 10px;
        }

        ${Actions} {
          margin-top: 10px;
        }

        ${ActionButton} {
          width: 24px;
          height: 24px;

          img {
            width: 14px;
            height: 14px;
          }
        }

        &:hover {
          transform: scale(1.05);
        }

        @media ${breakpoint.lg} {
          width: calc(20% - 20px);
        }

        @media ${breakpoint.xl} {
          width: calc(16.66% - 20px);
        }

        @media ${breakpoint.xxl} {
          width: calc(12.5% - 20px);
        }
      `;
    }

    if (view === 'list') {
      return css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 30px 15px 0;
        border-bottom: 1px rgba(0, 0, 0, 0.1) solid;

        ${Cover} {
          width: 50px;
          height: 50px;
          margin-right: 15px;
        }
      `;
    }

    return null;
  }}
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, transform 0.3s ease-in-out;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const NoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
`;

export const AlbumRow = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const CheckboxWrapper = styled.div`
  /* margin-left: -15px; */
  flex: 0 0 40px;
  margin-right: 15px;
`;

export const BatchActionsBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedCounter = styled.div`
  margin-right: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: 10px;
  }
`;
